import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores';

export const PRIVACY_ACCEPTED_KEY = 'intellio-privacy-accepted';

/**
 * 全站條款守衛：登入後若尚未同意條款（後端 privacyAccepted ≠ true 且 localStorage 無紀錄），
 * 不論進到哪個 route 都導回 Landing（'/'），由 Landing 的條款 gate 決定同意或登出。
 * 解決「直接打網址進內頁繞過條款」的問題。掛在 App 的 Router 內。
 */
export function TermsGuard() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, user, hasHydrated } = useAuthStore();

  useEffect(() => {
    if (!hasHydrated || !isAuthenticated()) return;
    if (location.pathname === '/') return; // Landing 本身即 gate
    if (!user) return; // profile 尚未載入，先不動（避免誤踢、避免吃掉 deep link）

    const accepted =
      user.privacyAccepted === true || localStorage.getItem(PRIVACY_ACCEPTED_KEY) === 'true';
    if (!accepted) navigate('/', { replace: true });
  }, [location.pathname, user, hasHydrated, isAuthenticated, navigate]);

  return null;
}
